import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
https://developers.facebook.com/docs/marketing-api/validation/#placement
https://developers.facebook.com/docs/marketing-api/targeting-specs/#newplacement
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import numberArrayGenerator from 'number-array-generator';
import { changeConfigDataValue, getReachEstimate, updateAudience } from 'redux/modules/audience';
import * as _ from 'lodash';
import Toggle from 'material-ui/Toggle';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import { Accordion } from 'components';
import * as styles from './Audiences.scss';
var AudiencePlacement = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    gettingSavedAudiences: state.adsAudiences.gettingSavedAudiences,
    audience: state.audience,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    targetingConfigData: state.audience && state.audience.FacebookTargetingConfig && state.audience.FacebookTargetingConfig.data ? state.audience.FacebookTargetingConfig.data : null,
    organization: state.organization.current,
    theme: state.theme,
    formValues: state.adBuilder && state.adBuilder[orgId] ? _objectSpread({}, state.adBuilder[orgId]) : []
  };
}, {
  changeConfigDataValue: changeConfigDataValue,
  getReachEstimate: getReachEstimate,
  updateAudience: updateAudience
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudiencePlacement, _Component);

  var _super = _createSuper(AudiencePlacement);

  function AudiencePlacement() {
    var _this;

    _classCallCheck(this, AudiencePlacement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getReachAndUpdateAudience", function () {
      setTimeout(function () {
        _this.props.getReachEstimate(_this.props.organization.id, _this.props.adAccount.adAccountId, _this.props.targetingConfigData).then(function () {
          _this.props.updateAudience(_this.props.organization.id, _this.props.audience.name, _this.props.audience.FacebookTargetingConfig.data, _this.props.audience.FacebookTargetingConfigId, _this.props.reachEstimate, _this.props.targetingSentences);
        });
      }, 500);
    });

    _defineProperty(_assertThisInitialized(_this), "updatePageLikePlacements", function () {
      _this.props.changeConfigDataValue('facebook_positions', ['feed']);

      _this.handlePlatformChange('instagram', false); // cheap way to wait for redux store to update


      setTimeout(function () {
        _this.handlePlatformChange('messenger', false);
      }, 150);
      setTimeout(function () {
        _this.handlePlatformChange('audience_network', false);
      }, 350);
    });

    _defineProperty(_assertThisInitialized(_this), "updateLeadPlacements", function () {
      _this.props.changeConfigDataValue('facebook_positions', ['feed']); // cheap way to wait for redux store to update


      _this.handlePlatformChange('messenger', false);

      setTimeout(function () {
        _this.handlePlatformChange('audience_network', false);
      }, 150);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeviceChange", function (device, checked) {
      var newValue = checked ? [].concat(_toConsumableArray(_this.props.targetingConfigData.device_platforms), [device]) : _this.props.targetingConfigData.device_platforms.filter(function (i) {
        return i !== device;
      });

      _this.props.changeConfigDataValue('device_platforms', newValue);

      _this.getReachAndUpdateAudience();

      if (_this.props.adType !== 'pageLikes') {
        if (checked) {
          if (device === 'mobile') {
            // only FB feed and right_hand_column are options when not targeting mobile (except for leadGen, right_hand not an option)
            _this.props.changeConfigDataValue('facebook_positions', [].concat(_toConsumableArray(_this.props.targetingConfigData.facebook_positions), ['instant_article']));

            _this.handlePlatformChange('instagram', true); // cheap way to wait for redux store to update


            if (_this.props.adType !== 'leadGeneration') {
              setTimeout(function () {
                _this.handlePlatformChange('messenger', true);
              }, 150);
              setTimeout(function () {
                _this.handlePlatformChange('audience_network', true);
              }, 350);
            }
          } else {
            // right_hand_column placement only available on desktop
            if (_this.props.adType !== 'leadGeneration') {
              _this.props.changeConfigDataValue('facebook_positions', [].concat(_toConsumableArray(_this.props.targetingConfigData.facebook_positions), ['right_hand_column']));
            }
          }
        } else {
          // unchecked
          if (device === 'mobile') {
            _this.props.changeConfigDataValue('facebook_positions', _this.props.targetingConfigData.facebook_positions.filter(function (p) {
              return p !== 'instant_article';
            }));

            _this.handlePlatformChange('instagram', false); // cheap way to wait for redux store to update


            setTimeout(function () {
              _this.handlePlatformChange('messenger', false);
            }, 150);
            setTimeout(function () {
              _this.handlePlatformChange('audience_network', false);
            }, 350);
          } else {
            // desktop
            _this.props.changeConfigDataValue('facebook_positions', _this.props.targetingConfigData.facebook_positions.filter(function (p) {
              return p !== 'right_hand_column';
            }));
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlatformChange", function (platform, checked) {
      var newValue = checked ? [].concat(_toConsumableArray(_this.props.targetingConfigData.publisher_platforms), [platform]) : _this.props.targetingConfigData.publisher_platforms.filter(function (i) {
        return i !== platform;
      });

      _this.props.changeConfigDataValue('publisher_platforms', newValue);

      if (checked) {
        if (platform === 'instagram') {
          _this.props.changeConfigDataValue("".concat(platform, "_positions"), ['stream', 'story']);
        } else if (platform === 'messenger') {
          _this.props.changeConfigDataValue("".concat(platform, "_positions"), ['messenger_home']);
        } else if (platform === 'audience_network') {
          _this.props.changeConfigDataValue("".concat(platform, "_positions"), ['classic', 'rewarded_video']);
        } else {
          _this.props.changeConfigDataValue("".concat(platform, "_positions"), ['feed', 'right_hand_column', 'instant_article']);
        }
      } else {
        _this.props.changeConfigDataValue("".concat(platform, "_positions"), []);
      }

      _this.getReachAndUpdateAudience();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePositionChange", function (key, position, checked) {
      var newValue = checked ? [].concat(_toConsumableArray(_this.props.targetingConfigData[key]), [position]) : _this.props.targetingConfigData[key].filter(function (i) {
        return i !== position;
      });

      _this.props.changeConfigDataValue(key, newValue);

      _this.getReachAndUpdateAudience();
    });

    return _this;
  }

  _createClass(AudiencePlacement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adType === 'pageLikes') {
        this.updatePageLikePlacements();
      }

      if (this.props.adType === 'leadGeneration') {
        this.updateLeadPlacements();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.audience.id !== this.props.audience.id && this.props.adType === 'pageLikes') {
        this.updatePageLikePlacements();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adType = _this$props.adType,
          targetingConfigData = _this$props.targetingConfigData;
      var device_platforms = targetingConfigData && targetingConfigData.device_platforms ? targetingConfigData.device_platforms : [];
      var publisher_platforms = targetingConfigData && targetingConfigData.publisher_platforms ? targetingConfigData.publisher_platforms : [];
      var facebook_positions = targetingConfigData && targetingConfigData.facebook_positions ? targetingConfigData.facebook_positions : [];
      var instagram_positions = targetingConfigData && targetingConfigData.instagram_positions ? targetingConfigData.instagram_positions : [];
      var audience_network_positions = targetingConfigData && targetingConfigData.audience_network_positions ? targetingConfigData.audience_network_positions : [];
      var messenger_positions = targetingConfigData && targetingConfigData.messenger_positions ? targetingConfigData.messenger_positions : [];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.placementRow,
        style: {
          borderBottom: 0,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          alignSelf: 'flex-start',
          paddingLeft: 12,
          paddingRight: 12,
          fontWeight: 'bold',
          color: '#000000'
        }
      }, "Device Types")), /*#__PURE__*/React.createElement("div", {
        className: styles.placementPositionsWrap,
        style: {
          borderLeft: 0,
          paddingBottom: 0
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: "Desktop",
        checked: device_platforms.includes('desktop'),
        onCheck: function onCheck(e, checked) {
          _this2.handleDeviceChange('desktop', checked);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Mobile",
        checked: device_platforms.includes('mobile'),
        onCheck: function onCheck(e, checked) {
          _this2.handleDeviceChange('mobile', checked);
        }
      })), /*#__PURE__*/React.createElement(Accordion, {
        name: "placement",
        id: "placement",
        labelStyle: {
          width: 200
        },
        style: {
          border: 0,
          marginTop: 0
        },
        tabStyle: {
          background: 'none'
        },
        sections: [{
          id: 'advanced_placement',
          label: 'Advanced Placement',
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            style: {
              border: '1px solid #f1f1f1',
              borderRadius: 2,
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.placementRow
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              alignSelf: 'flex-start',
              paddingLeft: 12,
              paddingRight: 12,
              fontWeight: 'bold',
              color: '#000000'
            }
          }, "Facebook"), /*#__PURE__*/React.createElement("div", {
            className: styles.placementPositionsWrap
          }, /*#__PURE__*/React.createElement(Checkbox, {
            disabled: adType === 'pageLikes' || adType === 'leadGeneration',
            label: "Feed",
            checked: facebook_positions.includes('feed'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('facebook_positions', 'feed', checked);
            }
          }), /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !device_platforms.includes('mobile') || adType === 'pageLikes',
            label: "Instant Articles",
            checked: facebook_positions.includes('instant_article'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('facebook_positions', 'instant_article', checked);
            }
          }), /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !device_platforms.includes('desktop') || adType === 'pageLikes' || adType === 'leadGeneration',
            label: "Right Column",
            checked: facebook_positions.includes('right_hand_column'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('facebook_positions', 'right_hand_column', checked);
            }
          }))), /*#__PURE__*/React.createElement("div", {
            className: styles.placementRow
          }, /*#__PURE__*/React.createElement(Toggle, {
            disabled: !device_platforms.includes('mobile') || adType === 'pageLikes' || this.props.formValues && !this.props.formValues.adAccountConnectedInstagramId,
            label: "Instagram",
            toggled: publisher_platforms.includes('instagram'),
            onToggle: function onToggle(e, checked) {
              _this2.handlePlatformChange('instagram', checked);
            },
            style: {
              flex: '0 0 25%',
              paddingLeft: 12,
              paddingRight: 12
            },
            labelStyle: {
              fontWeight: 'bold',
              color: '#000000'
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: styles.placementPositionsWrap
          }, /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !publisher_platforms.includes('instagram') || adType === 'pageLikes',
            label: "Stream",
            checked: instagram_positions.includes('stream'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('instagram_positions', 'stream', checked);
            }
          }), /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !publisher_platforms.includes('instagram') || adType === 'pageLikes',
            label: "Stories",
            checked: instagram_positions.includes('story'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('instagram_positions', 'story', checked);
            }
          }))), /*#__PURE__*/React.createElement("div", {
            className: styles.placementRow
          }, /*#__PURE__*/React.createElement(Toggle, {
            disabled: !device_platforms.includes('mobile') || adType === 'pageLikes' || adType === 'leadGeneration',
            label: "Audience Network",
            toggled: publisher_platforms.includes('audience_network'),
            onToggle: function onToggle(e, checked) {
              _this2.handlePlatformChange('audience_network', checked);
            },
            style: {
              flex: '0 0 25%',
              paddingLeft: 12,
              paddingRight: 12
            },
            labelStyle: {
              fontWeight: 'bold',
              color: '#000000'
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: styles.placementPositionsWrap
          }, /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !publisher_platforms.includes('audience_network') || adType === 'pageLikes',
            label: "Classic",
            checked: audience_network_positions.includes('classic'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('audience_network_positions', 'classic', checked);
            }
          }), /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !publisher_platforms.includes('audience_network') || adType === 'pageLikes',
            label: "Rewarded Video",
            checked: audience_network_positions.includes('rewarded_video'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('audience_network_positions', 'rewarded_video', checked);
            }
          }))), /*#__PURE__*/React.createElement("div", {
            className: styles.placementRow
          }, /*#__PURE__*/React.createElement(Toggle, {
            disabled: !device_platforms.includes('mobile') || adType === 'pageLikes' || adType === 'leadGeneration',
            label: "Messenger",
            toggled: publisher_platforms.includes('messenger'),
            onToggle: function onToggle(e, checked) {
              _this2.handlePlatformChange('messenger', checked);
            },
            style: {
              flex: '0 0 25%',
              paddingLeft: 12,
              paddingRight: 12
            },
            labelStyle: {
              fontWeight: 'bold',
              color: '#000000'
            }
          }), /*#__PURE__*/React.createElement("div", {
            className: styles.placementPositionsWrap
          }, /*#__PURE__*/React.createElement(Checkbox, {
            disabled: !publisher_platforms.includes('messenger') || adType === 'pageLikes',
            label: "Home",
            checked: messenger_positions.includes('messenger_home'),
            onCheck: function onCheck(e, checked) {
              _this2.handlePositionChange('messenger_positions', 'messenger_home', checked);
            }
          })))), /*#__PURE__*/React.createElement("div", {
            style: {
              fontSize: 14,
              marginTop: 12,
              marginLeft: 24
            }
          }, "* Not all placements are available for all ad types."))
        }]
      }));
    }
  }]);

  return AudiencePlacement;
}(Component)) || _class);
export { AudiencePlacement as default };